import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation, Navigate } from "react-router-dom";
import StripeCheckoutPage from "./StripeCheckoutPage";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export default function StripeCheckoutWrapper() {
  const location = useLocation();
  const paymentIntent = location.state?.paymentIntent;

  if (!paymentIntent?.client_secret) {
    return <Navigate to="/" replace />;
  }

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: paymentIntent.client_secret,
        appearance: { theme: "stripe" },
      }}
    >
      <StripeCheckoutPage />
    </Elements>
  );
}
